"use strict";
// Indian company tax-ID formats, shared by the frontend form and the backend
// create/update schemas so the rule and the user-facing copy live in one place.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAN_ERROR_MESSAGE = exports.PAN_REGEX = exports.IEC_ERROR_MESSAGE = exports.IEC_REGEX = void 0;
// India's IEC is the company's PAN — a 10-character alphanumeric code
// (e.g. ANDPS3737L), not a 10-digit number. Callers upper-case the input before
// matching, so any case is accepted and the stored value stays canonical.
exports.IEC_REGEX = /^[A-Z0-9]{10}$/u;
exports.IEC_ERROR_MESSAGE = 'IEC must be 10 characters (A–Z and 0–9).';
// Indian PAN: five letters, four digits, then a trailing letter (AAAAA9999A).
exports.PAN_REGEX = /^[A-Z]{5}\d{4}[A-Z]$/u;
exports.PAN_ERROR_MESSAGE = 'PAN must match pattern AAAAA9999A';
//# sourceMappingURL=tax-ids.js.map